<!-- eslint-disable no-trailing-spaces -->
<template>
  <div class="d-flex main-container">
    <!-- Side Menu -->
    <!-- In your main component template, replace the side menu section with: -->
     <div class="side-nav">
        <side-menu 
          :active-item="activeMenu" 
          @menu-change="handleMenuChange"
        />
    </div>

    
    <!-- Main Content -->
    <div class="main-content">
      <b-container class="touchpoint-dashboard">
        <b-card class="dashboard-card content-card">
          <!-- Data Table Section -->
          <b-card-body>
            <!-- Replace the current flex container with Bootstrap grid -->
            <div class="row mb-0" name="data-squares">
              <div class="col-xl-4 col-lg-6 col-12 mb-3">
                <div class="data-square">
                  <div class="p-2 d-flex flex-column h-100">
                    <!-- Date Range -->
                    <div class="flex row justify-content-between pr-3 pl-3">
                      <h5 class="mb-3">Filter</h5>
                      <div>
                        <b-button 
                          @click="subtractDay"
                          variant="light"
                          style="background-color: dimgray; height: 2em; font-weight: bolder;"
                          class="b-flex justify-content-between align-items-center">
                          <font-awesome-icon style="height: 100%; width: 100%;" :icon="icons.faAngleLeft" class="text-white"/>
                        </b-button>
                        
                        <b-button 
                          @click="addDay"
                          variant="light"
                          style="background-color: dimgray; height: 2em; font-weight: bolder;"
                          class="b-flex justify-content-between align-items-center">
                          <font-awesome-icon style="height: 100%; width: 100%;" :icon="icons.faAngleRight" class="text-white"/>
                        </b-button>
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="date-range-picker" class="font-weight-bold d-block mb-2 text-muted"><h6>Date Range:</h6></label>
                      <b-input-group class="d-flex flex-row gap-2">
                        <b-form-datepicker 
                          id="start-date-picker" 
                          :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric', weekday: 'long' }"
                          nav-button-variant="dark"
                          selected-variant="secondary"
                          v-model="filters.startDate"
                          :max="filters.endDate"
                          class="w-50"
                        ></b-form-datepicker>
                        <b-form-datepicker 
                          id="end-date-picker" 
                          :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric', weekday: 'long' }"
                          nav-button-variant="dark"
                          selected-variant="secondary"
                          v-model="filters.endDate"
                          :min="filters.startDate"
                          class="w-50"
                        ></b-form-datepicker>
                      </b-input-group>
                    </div>

                      <!-- Location -->
                      <div class="mb-3">
                        <label for="location-select" class="font-weight-bold d-block mb-2 text-muted"><h6>Location:</h6></label>
                        <b-form-select 
                          id="location-select" 
                          v-model="filters.location" 
                          :options="locationOptions" 
                          class="w-100"
                        ></b-form-select>
                      </div>

                    <!-- Go Button - Using mt-auto to push to bottom and flex-grow for spacing -->
                    <div class="mt-3">
                      <b-button 
                        variant="success"
                        class="w-100"
                        @click="fetchData" 
                        :disabled="loading"
                        size="md"
                      >
                        <i class="fas fa-sync-alt me-2"></i>
                        {{ loading ? 'Loading...' : 'Fetch Data' }}
                      </b-button>
                    </div>
                  </div>
                </div>


                <div class="side-search" id="my-search">
                    <!-- <h5>Search</h5> -->
                    <b-form-input class="my-search" v-model="filters.search" placeholder="Search..."></b-form-input>
                </div>

              </div>
              
              <div class="col-xl-4 col-lg-6 col-12 mb-3">
                <div class="data-square">
                  <div class="chart-container">
                    <canvas ref="matrixChart"></canvas>
                  </div>
                </div>
              </div>
              
              <div class="col-xl-4 col-lg-6 col-12 mb-3">
                <div class="data-square">
                  <div class="p-2 d-flex flex-column h-100 overflow-auto">
                    <small class="text-muted">Total Sales: ${{ totalSales.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</small>
                    <small class="text-muted">*Does not include Westland Square yet.*</small>
                    <h5 class="mb-2 ">Top Performers</h5>
                    
                    <!-- Stars Section -->
                    <div class="mb-3">
                      <h6 class="text-warning mb-2">
                        <i class="fas fa-star me-1"></i> Stars
                        <small class="text-muted">(High Revenue, High Popularity)</small>
                      </h6>
                      <div v-if="getTopItemsByQuadrant().stars.length > 0">
                        <div v-for="(item, index) in getTopItemsByQuadrant().stars" :key="'star-' + index" 
                            class="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded">
                          <div class="flex-grow-1">
                            <strong class="d-block" :title="item.name">{{ item.name }}</strong>
                            <small class="text-muted">${{ item.totalSales.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</small>
                          </div>
                          <div class="text-end">
                            <small class="text-success d-block">{{ item.percentOfRevenue.toFixed(1) }}% Rev</small>
                            <small class="text-primary">{{ item.percentOfOrders.toFixed(1) }}% Ord</small>
                          </div>
                        </div>
                      </div>
                      <p v-else class="text-muted small mb-0">No star items</p>
                    </div>

                    <!-- Plow Horses Section -->
                    <div class="mb-3">
                      <h6 class="text-success mb-2">
                        <i class="fas fa-horse me-1"></i> Plow Horses
                        <small class="text-muted">(High Popularity, Low Revenue)</small>
                      </h6>
                      <div v-if="getTopItemsByQuadrant().plowHorses.length > 0">
                        <div v-for="(item, index) in getTopItemsByQuadrant().plowHorses" :key="'plow-' + index" 
                            class="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded">
                          <div class="flex-grow-1">
                            <strong class="d-block" :title="item.name">{{ item.name }}</strong>
                            <small class="text-muted">${{ item.totalSales.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</small>
                          </div>
                          <div class="text-end">
                            <small class="text-warning d-block">{{ item.percentOfRevenue.toFixed(1) }}% Rev</small>
                            <small class="text-primary">{{ item.percentOfOrders.toFixed(1) }}% Ord</small>
                          </div>
                        </div>
                      </div>
                      <p v-else class="text-muted small mb-0">No plow horse items</p>
                    </div>

                    <!-- Puzzles Section -->
                    <div class="mb-3">
                      <h6 class="text-info mb-2">
                        <i class="fas fa-puzzle-piece me-1"></i> Puzzles
                        <small class="text-muted">(High Revenue, Low Popularity)</small>
                      </h6>
                      <div v-if="getTopItemsByQuadrant().puzzles.length > 0">
                        <div v-for="(item, index) in getTopItemsByQuadrant().puzzles" :key="'puzzle-' + index" 
                            class="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded">
                          <div class="flex-grow-1">
                            <strong class="d-block" :title="item.name">{{ item.name }}</strong>
                            <small class="text-muted">${{ item.totalSales.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</small>
                          </div>
                          <div class="text-end">
                            <small class="text-success d-block">{{ item.percentOfRevenue.toFixed(1) }}% Rev</small>
                            <small class="text-warning">{{ item.percentOfOrders.toFixed(1) }}% Ord</small>
                          </div>
                        </div>
                      </div>
                      <p v-else class="text-muted small mb-0">No puzzle items</p>
                    </div>

                    <!-- Dogs Section -->
                    <div>
                      <h6 class="text-danger mb-2">
                        <i class="fas fa-times me-1"></i> Dogs
                        <small class="text-muted">(Low Revenue, Low Popularity)</small>
                      </h6>
                      <div v-if="getTopItemsByQuadrant().dogs.length > 0">
                        <div v-for="(item, index) in getTopItemsByQuadrant().dogs" :key="'dog-' + index" 
                            class="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded">
                          <div class="flex-grow-1">
                            <strong class="d-block" :title="item.name">{{ item.name }}</strong>
                            <small class="text-muted">${{ item.totalSales.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</small>
                          </div>
                          <div class="text-end">
                            <small class="text-danger d-block">{{ item.percentOfRevenue.toFixed(1) }}% Rev</small>
                            <small class="text-warning">{{ item.percentOfOrders.toFixed(1) }}% Ord</small>
                          </div>
                        </div>
                      </div>
                      <p v-else class="text-muted small mb-0">No dog items</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-table
              striped
              hover
              :items="filteredData"
              :fields="fields"
              :filter="filters.search"
              :busy="loading"
              show-empty
              responsive
              class="sales-table"
            >
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template #empty>
                <div class="text-center text-muted">
                  <h4>No data available</h4>
                  <p>Try refreshing the page or check your connection</p>
                </div>
              </template>

              <!-- Format Total Sales as Currency -->
              <template #cell(Total_Sales_Dollars)="data">
                ${{ data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </template>

              <!-- Format Number of Orders with commas -->
              <template #cell(Order_Count)="data">
                {{ data.value.toLocaleString() }}
              </template>

              <!-- Format Total Sales as Currency -->
              <template #cell(Percent_of_Orders)="data">
                  {{ data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}%
              </template>

              <!-- Format Number of Orders with commas -->
              <template #cell(Percent_of_Revenue)="data">
                  {{ data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}%
              </template>
            </b-table>

            <div class="d-flex justify-content-between align-items-center mt-3">
              <div>
                <strong>Total Records:</strong> {{ filteredData.length }}
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-container>
    </div>
  </div>
</template>

<!-- eslint-disable no-trailing-spaces -->
<script>
import { DateTime } from "luxon";
import AuthMixin from "../../mixins/auth.mixin";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Api } from "shared/api";
import { apiHandler } from "@/services/api-handler";
import SideMenu from '@/components/admin-nav.vue';

import { 
faDollarSign, 
faTruck, 
faBicycle, 
faStore, 
faSyncAlt,
faTrash,
faCheckCircle,
faChartLine,
faExclamationTriangle,
faAngleRight,
faAngleLeft
} from '@fortawesome/free-solid-svg-icons';
// Remove the direct service import and use your existing API pattern

export default {
name: 'tp-analytics',
mixins: [AuthMixin],
components: {
  SideMenu,
  FontAwesomeIcon
},
data() {
  const now = DateTime.now().setZone('America/New_York');
  const firstDay = now.startOf('month');
  // const lastDay = now.startOf('month').plus({ days: 1 });
  const lastDay = now.startOf('month');
  
  // Helper function to format date
  const formatDate = (date) => {
      return date.toFormat('yyyy-MM-dd');
  };

  return {
    chartUpdateTimeout: null,
    loading: false,
    allowedIds: [],
    connectionTested: false,
    connectionError: null,
    tableData: [],
    matrixChart: null,
    activeMenu: 'Menu',
    filters: {
      startDate: formatDate(firstDay),
      endDate: formatDate(lastDay),
      location: null,
      query: 'Menu Matrix'    ,
      search: ''       
    },
    queryOptions: [ 'Menu Matrix' ],
    locationOptions: [
        { value: null, text: 'All Locations' },
        { value: 'cs001~6a6861cee116a411daf7257b768684f11', text: 'Royal Oak - 11 Mile' },
        { value: 'cs002~c99923bf0c29c39e512f9cd5a1ccffb71', text: 'Royal Oak - Woodward' },
        { value: 'cs003~53c0e59c5fb5a4b676717978476b2cbb1', text: 'Warren - Ryan' },
        { value: 'cs004~2c16af0ed018da5378e45c0d933d2abe1', text: 'Warren - Schoenherr' },
        { value: 'cs005~b46e2e33bd41887baa27551ff98621a61', text: 'New Baltimore' },
        { value: 'cs006~9066e49435610ebbdaa8df630b5df3761', text: 'Grosse Pointe' },
        { value: 'cs007~f809e2deca9605fab245518e0340dd3b1', text: 'St. Clair Shores' },
        { value: 'cs008~57296834507ff8a37faf4f393bbddde51', text: 'Lincoln Park' },
        { value: 'cs009~1f38264643f0c3890262073e3b97588c1', text: 'Sterling Heights' },
        { value: 'cs010~cc0cab7dc43218119bb8cf2f298860611', text: 'Westland' },
        { value: 'cs011~703345b217d1b56b60b447a1b6ff5a441', text: 'Macomb Township' },
        { value: 'cs012~52c1952e9adbb62d1acec487b8b568551', text: 'Rochester' },
        { value: 'cs013~ea4602ebe1e3dd4066e2369bc91f34f11', text: 'Detroit' },
        { value: 'cs014~b9c028ce92edde3680eacfee75b701ae1', text: 'Clarkson' },
        { value: 'cs015~4e5ece70d119ca0bb8f94502e95ac1191', text: 'Clawson' },
        { value: 'cs016~ed873ecd067cd8608e6c19b1bbb36b341', text: 'Southfield' },
        { value: 'cs017~8d3b502ef4ddc533b78c6310e43550601', text: 'Livonia' },
        { value: 'cs018~cfdf796adf8452b0a55654a6530a25041', text: 'Riverview' },
        { value: 'cs019~4d6704df7f00688bb3df6a8ddc1b93441', text: 'Clinton Township' },
        { value: 'cs020~3556ff4772b8dbd30303cc5b4c3889a31', text: 'Shelby Township' },
        { value: 'cs021~ff5907d6686f7d8267d2fd7b3f134da31', text: 'Brownstown' },
        { value: 'cs022~6410a2fcaf82c9ba914ee9569e9832761', text: 'Bloomfield Township' },
        { value: 'cs023~cf16d220ae79e94f7cfa13d5847cda311', text: 'Ypsilanti' },
        { value: 'cs024~90cd7a9e6c3e34a8a15203dd8f5cfb211', text: 'Grand Blanc' },
        { value: 'cs025~f597f3f279b81ebd354cab7ab184f68a1', text: 'Sterling Heights - 18 Mile' },
        { value: 'cs026~6e124a7877a402b609e2d9b3da2dd2541', text: 'Oxford' }
    ],
    fields: [
      {
        key: 'category',
        label: 'Category',
        sortable: true,
        class: 'text-left',
        thStyle: { width: '15%' }
      },
      {
        key: 'main',
        label: 'Item',
        sortable: true,
        class: 'text-left',
        thStyle: { width: '15%' }
      },
      {
        key: 'side',
        label: 'Side',
        sortable: true,
        class: 'text-left',
        thStyle: { width: '15%' }
      },
      {
        key: 'order_count',
        label: 'Count',
        sortable: true,
        class: 'text-right',
        thStyle: { width: '5%' }
      },
      {
        key: 'total_sales',
        label: 'Sales ($)',
        sortable: true,
        class: 'text-right',
        thStyle: { width: '15%' }
      },
      {
        key: 'Percent_of_Orders',
        label: '% of Orders',
        sortable: true,
        class: 'text-right',
        thStyle: { width: '11%' }
      },
      {
        key: 'Percent_of_Revenue',
        label: '% of Revenue',
        sortable: true,
        class: 'text-right',
        thStyle: { width: '12%' }
      }
    ],
    icons: {
      faDollarSign,
      faTruck, 
      faBicycle, 
      faStore, 
      faSyncAlt,
      faTrash,
      faCheckCircle,
      faExclamationTriangle,
      faChartLine,
      faAngleRight,
      faAngleLeft
    },
  };
},
async mounted() {
  try {
      if (!this.user && this.getUser) {
        this.user = this.getUser();
      }

      if (this.user && this.user.id) {
        try {
          const rawLocations = await apiHandler(() => Api.user[this.user.id].locations.Get());
          this.allowedIds = rawLocations.map(id => String(id));
          console.log('Allowed Location IDs:', this.allowedIds);

          // 1. Filter the options
          const filtered = this.locationOptions.filter(item => {
            // Always keep the "All Locations" option (where value is null)
            if (item.value === null && this.allowedIds.length === 28) return true;

            const locNumber = this.getLocationNumber(item.text);
            return locNumber && this.allowedIds.includes(String(locNumber));
          });

          // 2. ASSIGN IT back to the data property to trigger the UI update
          this.locationOptions = filtered;

          // 3. Optional: If the current selection isn't in the new list, reset it
          if (!this.locationOptions.find(o => o.value === this.filters.location)) {
            this.filters.location = this.locationOptions[0].value; // Default to "All Locations" or first available
          }

        } catch (error) {
          console.error('Error fetching user locations:', error);
        }
      }
      await this.fetchData();
  } catch (error) {
    console.error('❌ Connection failed:', error);
  }
},
  beforeUnmount() {
    // Destroy chart when component is unmounted
    if (this.matrixChart) {
      this.matrixChart.destroy();
      this.matrixChart = null;
    }
  },
  methods: {
    getLocationNumber(location) {
      const mappings = {
        'Royal Oak - 11 Mile	': '1',
        'Royal Oak - Woodward': '2', 
        'Warren - Ryan': '3',
        'Warren - Schoenherr	': '4',
        'New Baltimore': '5',
        'Grosse Pointe': '6',
        'St. Clair Shores': '7',
        'Lincoln Park': '8',
        'Sterling Heights - Van Dyke': '9',
        'Westland': '10',
        'Macomb Township': '11',
        'Rochester': '12',
        'Detroit': '13',
        'Clarkson': '14',
        'Clawson': '15',
        'Southfield': '16',
        'Livonia': '17',
        'Riverview': '18',
        'Clinton Township': '19',
        'Shelby Township': '20',
        'Brownstown': '21',
        'Bloomfield Township': '22',
        'Ypsilanti': '23',
        'Grand Blanc': '24',
        'Sterling Heights - 18 Mile': '25',
        'Oxford': '26'
      };
      
      // Find matching location
      for (const [key, value] of Object.entries(mappings)) {
        if (location.includes(key) || key.includes(location)) {
          return value;
        }
      }
      
      return null;
    },
    addDay() {
      const startDate = DateTime.fromISO(this.filters.startDate);
      const endDate = DateTime.fromISO(this.filters.endDate);
      
      this.filters.startDate = startDate.plus({ days: 1 }).toFormat('yyyy-MM-dd');
      this.filters.endDate = endDate.plus({ days: 1 }).toFormat('yyyy-MM-dd');
    },
    subtractDay() {
      const startDate = DateTime.fromISO(this.filters.startDate);
      const endDate = DateTime.fromISO(this.filters.endDate);
      
      this.filters.startDate = startDate.minus({ days: 1 }).toFormat('yyyy-MM-dd');
      this.filters.endDate = endDate.minus({ days: 1 }).toFormat('yyyy-MM-dd');
    },
    exportToCSV() {
      if (!this.filteredData.length) {
        this.$bvToast.toast('No data to export', {
          title: 'Export Error',
          variant: 'warning',
          solid: true
        });
        return;
      }

      try {
        // Use your table fields for headers and column order
        const headers = this.fields.map(field => field.label);
        const keys = this.fields.map(field => field.key);
        
        // Create CSV content
        let csvContent = headers.join(',') + '\n';
        
        // Add rows
        this.filteredData.forEach(item => {
          const row = keys.map(key => {
            const value = item[key] || '';
            
            // Handle different data types
            if (value === null || value === undefined) {
              return '';
            }
            
            // Format numbers (remove currency formatting for CSV)
            if (typeof value === 'number') {
              // Format to 2 decimal places
              return value.toFixed(2);
            }
            
            // Handle strings that might contain commas or quotes
            const stringValue = String(value);
            if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
              // Escape quotes and wrap in quotes
              return `"${stringValue.replace(/"/g, '""')}"`;
            }
            
            return stringValue;
          });
          
          csvContent += row.join(',') + '\n';
        });

        // Create and trigger download
        this.downloadCSV(csvContent, 'sales-data');
        
      } catch (error) {
        console.error('Error exporting CSV:', error);
        this.$bvToast.toast('Failed to export CSV: ' + error.message, {
          title: 'Export Error',
          variant: 'danger',
          solid: true
        });
      }
    },

    downloadCSV(csvContent, baseFilename) {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      
      // Create filename with timestamp
      const timestamp = new Date().toISOString().slice(0, 19).replace(/[:]/g, '-');
      const filename = `${baseFilename}_${timestamp}.csv`;
      
      if (navigator.msSaveBlob) {
        // For IE/Edge
        navigator.msSaveBlob(blob, filename);
      } else {
        // For other browsers
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    },
    getMedian(values) {
    if (!values.length) return 0;
    const sorted = [...values].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 !== 0
      ? sorted[mid]
      : (sorted[mid - 1] + sorted[mid]) / 2;
  },
  getTopItemsByQuadrant() {
    if (!this.filteredData || this.filteredData.length === 0) {  // Changed from tableData to filteredData
      return {
        stars: [],
        plowHorses: [],
        puzzles: [],
        dogs: []
      };
    }

    // Calculate averages for quadrant boundaries using filteredData
    const revenueValues = this.filteredData.map(i => i.Percent_of_Revenue);
    const orderValues = this.filteredData.map(i => i.Percent_of_Orders);
    const centerRevenue = this.getMedian(revenueValues);
    const centerOrders = this.getMedian(orderValues);


    // Categorize items into quadrants using filteredData
    const stars = [];
    const plowHorses = [];
    const puzzles = [];
    const dogs = [];

    this.filteredData.forEach(item => {  // Changed from tableData to filteredData
      const quadrantItem = {
        name: `${item.main}${item.side ? ' + ' + item.side : ''}`,
        category: item.category,
        orderCount: item.order_count,
        totalSales: item.total_sales,
        percentOfOrders: item.Percent_of_Orders,
        percentOfRevenue: item.Percent_of_Revenue
      };

      if (item.Percent_of_Revenue >= centerRevenue && item.Percent_of_Orders >= centerOrders) {
        stars.push(quadrantItem);
      } else if (item.Percent_of_Revenue < centerRevenue && item.Percent_of_Orders >= centerOrders) {
        plowHorses.push(quadrantItem);
      } else if (item.Percent_of_Revenue >= centerRevenue && item.Percent_of_Orders < centerOrders) {
        puzzles.push(quadrantItem);
      } else {
        dogs.push(quadrantItem);
      }
    });

    // Sort each quadrant by revenue (descending) and get top 3
    const sortByRevenue = (a, b) => b.totalSales - a.totalSales;
    
    return {
      stars: stars.sort(sortByRevenue).slice(0, 10),
      plowHorses: plowHorses.sort(sortByRevenue).slice(0, 10),
      puzzles: puzzles.sort(sortByRevenue).slice(0, 10),
      dogs: dogs.sort(sortByRevenue).slice(0, 10)
    };
  },
  handleMenuChange(menuName) {
    this.activeMenu = menuName;
    // Add any navigation logic here
    console.log('Menu changed to:', menuName);
  },
  formatDate(date) {
      return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
  },
  async testConnection() {
    try {
      const result = await apiHandler(() => Api.clickhouse.test.Get());
      this.connectionTested = true;
      if (result.success) {
          console.log(result);
          
        this.connectionError = null;
        return true;
      } else {
        this.connectionError = result.error;
        return false;
      }
    } catch (error) {
      this.connectionTested = true;
      this.connectionError = true;
      return false;
    }
  },
  async fetchData() {
    this.loading = true;
    try {
      this.tableData = await apiHandler(() => 
        Api.clickhouse.analytics.Get({
          location: this.filters.location,
          startDate: this.filters.startDate,
          endDate: this.filters.endDate,
        })
      );
      
      // Create or update chart after data is loaded
      this.$nextTick(() => {
        this.createMatrixChart();
      });
    } catch (error) {
      console.error('Error fetching data:', error);
      this.connectionError = error.message;
    } finally {
      this.loading = false;
    }
  },
  createMatrixChart() {
    if (!this.filteredData || this.filteredData.length === 0) return;  // Changed from tableData to filteredData

    // Destroy existing chart
    if (this.matrixChart) {
      this.matrixChart.destroy();
      this.matrixChart = null;
    }

    // Check if Chart is available
    if (typeof window.Chart === 'undefined') {
      console.error('Chart.js not loaded');
      return;
    }

    const revenueValues = this.filteredData.map(i => i.Percent_of_Revenue);
    const orderValues = this.filteredData.map(i => i.Percent_of_Orders);

    const centerRevenue = this.getMedian(revenueValues);
    const centerOrders = this.getMedian(orderValues);
    const minX = Math.min(...orderValues);
    const maxX = Math.max(...orderValues);
    const minY = Math.min(...revenueValues);
    const maxY = Math.max(...revenueValues);

    // distances in log space
    const leftX = Math.log10(centerOrders) - Math.log10(minX);
    const rightX = Math.log10(maxX) - Math.log10(centerOrders);
    const spanX = Math.max(leftX, rightX);

    const leftY = Math.log10(centerRevenue) - Math.log10(minY);
    const rightY = Math.log10(maxY) - Math.log10(centerRevenue);
    const spanY = Math.max(leftY, rightY);

    // rebuild symmetric bounds
    const xMin = Math.pow(10, Math.log10(centerOrders) - spanX);
    const xMax = Math.pow(10, Math.log10(centerOrders) + spanX);

    const yMin = Math.pow(10, Math.log10(centerRevenue) - spanY);
    const yMax = Math.pow(10, Math.log10(centerRevenue) + spanY);



    const scatterData = this.filteredData.map(item => {
      const popularity = item.Percent_of_Orders;
      const revenue = item.Percent_of_Revenue;

      let quadrant = '';
      let backgroundColor = '';

          if (revenue >= centerRevenue && popularity >= centerOrders) {
        quadrant = 'Stars';
        backgroundColor = 'rgba(255, 215, 0, 0.7)';
      } else if (revenue < centerRevenue && popularity >= centerOrders) {
        quadrant = 'Plow Horses';
        backgroundColor = 'rgba(144, 238, 144, 0.7)';
      } else if (revenue >= centerRevenue && popularity < centerOrders) {
        quadrant = 'Puzzles';
        backgroundColor = 'rgba(135, 206, 250, 0.7)';
      } else {
        quadrant = 'Dogs';
        backgroundColor = 'rgba(255, 99, 132, 0.7)';
      }

      return {
        x: popularity,
        y: revenue,
        label: `${item.Choice_Name}${item.Side_Choice ? ' + ' + item.Side_Choice : ''}`,
        details: {
          mainItem: item.category,
          choiceName: item.main,
          sideChoice: item.side,
          orderCount: item.order_count,
          totalSales: item.total_sales,
          percentOfOrders: item.Percent_of_Orders,
          percentOfRevenue: item.Percent_of_Revenue,
          quadrant: quadrant
        },
        backgroundColor: backgroundColor,
        borderColor: backgroundColor.replace('0.7', '1'),
        radius: 4
      };
    }
  );

    const ctx = this.$refs.matrixChart.getContext('2d');
    
    // Define the quadrant lines plugin
    const quadrantLinesPlugin = {
      id: 'quadrantLines',
      afterDraw(chart) {
        const ctx = chart.ctx;
        const xScale = chart.scales.x;
        const yScale = chart.scales.y;

        // Geometric midpoint for log scale
        const xCenterValue = centerOrders;
        const yCenterValue = centerRevenue;

        const xPixel = xScale.getPixelForValue(xCenterValue);
        const yPixel = yScale.getPixelForValue(yCenterValue);

        ctx.save();
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)';
        ctx.lineWidth = 1;
        ctx.setLineDash([]);

        // Vertical line
        ctx.beginPath();
        ctx.moveTo(xPixel, yScale.top);
        ctx.lineTo(xPixel, yScale.bottom);
        ctx.stroke();

        // Horizontal line
        ctx.beginPath();
        ctx.moveTo(xScale.left, yPixel);
        ctx.lineTo(xScale.right, yPixel);
        ctx.stroke();
        ctx.restore();

        // Labels stay visually centered in each quadrant
        ctx.save();
        ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
        ctx.font = '14px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const xCenter = (xScale.left + xScale.right) / 2;
        const yCenter = (yScale.top + yScale.bottom) / 2;
        const xQuarter = (xScale.right - xScale.left) / 4;
        const yQuarter = (yScale.bottom - yScale.top) / 4;

        ctx.fillText('Stars', xCenter + xQuarter, yCenter - yQuarter);
        ctx.fillText('Plow Horses', xCenter - xQuarter, yCenter - yQuarter);
        ctx.fillText('Puzzles', xCenter + xQuarter, yCenter + yQuarter);
        ctx.fillText('Dogs', xCenter - xQuarter, yCenter + yQuarter);

        ctx.restore();
      }
    };


    // Create the chart configuration with the plugin
    const chartConfig = {
      type: 'scatter',
      data: {
        datasets: [{
          label: 'Menu Items',
          data: scatterData,
          backgroundColor: scatterData.map(d => d.backgroundColor),
          borderColor: scatterData.map(d => d.borderColor),
          borderWidth: 1,
          pointRadius: scatterData.map(d => d.radius),
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: true,
            text: 'Menu Matrix',
            font: {
              size: 14
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const item = context.raw;
                return [
                  `Item: ${item.details.choiceName}`,
                  `Side: ${item.details.sideChoice || 'None'}`,
                  `Category: ${item.details.mainItem}`,
                  `Orders: ${item.details.orderCount.toLocaleString()}`,
                  `Revenue: $${item.details.totalSales.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
                  `% of Orders: ${item.x.toFixed(2)}%`,
                  `% of Revenue: ${item.y.toFixed(2)}%`,
                  `Quadrant: ${item.details.quadrant}`
                ];
              }
            }
          }
        },
        scales: {
          x: {
            type: 'logarithmic',
            min: xMin,
            max: xMax,
            ticks: { display: false },
            title: { display: true, text: 'Popularity' },
            grid: { display: false }
          },
          y: {
            type: 'logarithmic',
            min: yMin,
            max: yMax,
            ticks: { display: false },
            title: { display: true, text: 'Revenue' },
            grid: { display: false }
          }
        }
      },
      plugins: [quadrantLinesPlugin]
    };

    // Create the chart
    this.matrixChart = new window.Chart(ctx, chartConfig);

    // Remove the addQuadrantLines method call since we're using plugin now
  }
},
computed: {
  // Get filtered data based on search
  filteredData() {
    if (!this.filters.search) {
      return this.tableData;
    }
    
    const searchTerm = this.filters.search.toLowerCase();
    return this.tableData.filter(item => {
      const mainItem = item.category ? item.category.toLowerCase() : '';
      const choiceName = item.main ? item.main.toLowerCase() : '';
      const sideChoice = item.side ? item.side.toLowerCase() : '';
      const orderCount = item.order_count ? item.order_count.toString() : '';
      const totalSales = item.total_sales ? item.total_sales.toString() : '';
      
      return (
        mainItem.includes(searchTerm) ||
        choiceName.includes(searchTerm) ||
        sideChoice.includes(searchTerm) ||
        orderCount.includes(searchTerm) ||
        totalSales.includes(searchTerm)
      );
    });
  },
  totalSales() {
    return this.filteredData.reduce((sum, item) => {
      return sum + (item.total_sales || 0);
    }, 0);
  },
},
watch: {
  'filters.search': {
    handler(newSearch, oldSearch) {
      // Debounce the chart update to prevent excessive redraws
      if (this.chartUpdateTimeout) {
        clearTimeout(this.chartUpdateTimeout);
      }
      this.chartUpdateTimeout = setTimeout(() => {
        if (this.tableData.length > 0) {
          this.createMatrixChart();
        }
      }, 300);
    },
    immediate: false
  }
},
};
</script>

<style scoped>
/* Your existing styles remain the same */
.main-container {
  /* min-height: 100vh; */
  padding: 0.5rem 0rem 0.5rem 0rem;
}

.main-content {
  /* background-color: red; */
  flex-grow: 1;
  min-width: 0;
  margin: 0 1em;
  padding: 0em;
}

.content-card {
  border-radius: 0.5em !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  border: none;
  /* background-color: aquamarine; */
  width: 100%;
  margin: 0em;
  padding: 0em;
}

.touchpoint-dashboard {
  height: 100%;
  max-width: 1400px;
  padding: 0;
}

.dashboard-card {
  height: 100%;
  border-radius: inherit;
  /* background-color: violet; */
  width: 100%;
  margin: 0em;
  padding: 0em;
  padding: 1em 1em 0em 1em;

}

.card-body {
  padding: 0em;
}

.dashboard-header {
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.data-square {
  aspect-ratio: 1 / 1;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  position: relative;
}

.data-square-query {
  height: 19em;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  position: relative;
}

.data-square > div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}

.data-square .chart-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
}

/* Adjust for very small screens */
@media (max-width: 700px) {
  .data-square {
    aspect-ratio: 4 / 3;
    height: 20em;
    width: 20em;
  }
}

.matrix-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 5px;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 8px;
  border: 1px solid rgba(0,0,0,0.2);
}

.legend-color.stars {
  background-color: rgba(255, 215, 0, 0.7);
}

.legend-color.plow-horses {
  background-color: rgba(144, 238, 144, 0.7);
}

.legend-color.puzzles {
  background-color: rgba(135, 206, 250, 0.7);
}

.legend-color.dogs {
  background-color: rgba(255, 99, 132, 0.7);
}

.legend-text {
  font-size: 12px;
  font-weight: 500;
}

.clearfix {
  clear: both;
}

.sales-table {
  margin-top: 0px;
  margin-bottom: 0;
  border: none !important;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.sales-table thead th {
  border: none !important;
  font-weight: 500;
}

.sales-table tbody td {
  border: none;
  padding: 14px 16px;
  vertical-align: middle;
  border-color: #f1f3f7;
}

.loading-indicator {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255,255,255,.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
  margin-left: 10px;
}

.spinning-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.dashboard-icon {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  opacity: 0.8;
}

.menu-icon {
  font-size: 1rem;
  opacity: 0.8;
}
.side-nav {
  float: left;
  width: 15em !important;
  flex-shrink: 0;
  height: fit-content;
}

.side-search{
  position: absolute;
  bottom: 0px;
  left: 1em;
  right: 1em;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2); 
  border-radius: 10px;
  border: none;
  padding: 0em;
}
.side-search > .my-search {
  border: 0em !important;
  height: 3em !important;
}
</style>